import { t } from 'i18next';
import Image from 'next/image';
import { HiChevronRight } from 'react-icons/hi';

import i18n from '@/src/i18n';

import { StartTrialInput } from '../StartTrialInput';

const styles = {
  container: {
    background:
      'linear-gradient(180deg, rgba(242, 250, 255, 0) 0%, #F2FAFF 64.35%, #F2FAFF 100%)',
  },
};

function Heading({ customHeading }: { customHeading?: string[] }) {
  const defaultHeading = ['Get Started with', 'AbleSpace for FREE!'];

  const heading = customHeading || defaultHeading;

  return (
    <div className="px-4 text-center text-[28px] font-medium text-[#3D3E40] md:px-0 md:text-left md:text-[36px]">
      {i18n.t(heading[0] || '')}
      <br />
      {i18n.t(heading[1] || '')}
    </div>
  );
}

function EmailInput() {
  return (
    <div className="flex w-full flex-col items-center justify-between md:items-start md:gap-6">
      <div className="flex w-full">
        <input
          type="email"
          placeholder="Enter your email Address"
          className="h-[58px] flex-grow rounded-l-lg border-2 border-r-0 border-[#E4E4E4] bg-white px-5 py-4 text-base font-normal text-[#787878] md:w-[230px] lg:w-[300px]"
        />
        <button className="flex h-[58px] items-center justify-center rounded-r-lg bg-[#318AE5] px-4 text-base text-white focus:outline-none">
          <div className="flex items-center gap-1">
            <p className=" whitespace-nowrap md:text-lg ">
              {t('Start for Free!')}
            </p>
            <HiChevronRight size={24} />
          </div>
        </button>
      </div>
      <div>
        <p className="mt-4 pl-2 text-[18px] font-normal text-[#616366]">
          No Credit Card Required. Cancel Anytime 🙌
        </p>
      </div>
    </div>
  );
}

function TextArea({
  useEmail = false,
  heading,
}: {
  useEmail?: boolean;
  heading?: string[];
}) {
  return (
    <div className="mt-6 flex w-full flex-col items-center md:order-1 md:mt-0 md:max-w-[80%] md:items-start lg:max-w-[65%] xl:max-w-[50%]">
      <Heading customHeading={heading} />
      {useEmail ? (
        <div className="mt-4 flex flex-col px-10 md:px-0">
          <EmailInput />
        </div>
      ) : (
        <div className="mt-4 flex flex-col px-10 md:px-0">
          <StartTrialInput />
        </div>
      )}
    </div>
  );
}

export const Footertop = ({
  useEmail,
  heading,
}: {
  useEmail?: boolean;
  heading?: string[];
}) => {
  return (
    <div
      style={styles.container}
      className="overflow-hidden bg-origin-padding py-10 md:m-auto md:w-[90%] md:px-6 lg:w-[100%] lg:px-20 lg:py-16"
    >
      <div className="container mx-auto flex flex-col items-center justify-center md:w-full md:flex-row">
        <Image
          className="mx-auto w-[60%] md:order-2 md:mx-0 md:w-[40%] xl:w-[30%]"
          src="/images/footer-top.svg"
          alt="Kickstart your journey with a generous 1-month free trial. No strings attached."
          width={600}
          height={600}
        />
        <TextArea useEmail={useEmail} heading={heading} />
      </div>
    </div>
  );
};
